import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import { create } from "zustand";
import { cancelSlotApi } from "../api_layer/api";


export const useSlotCancellation = create((set) => ({
    slotCancellationLoading: false,
    isError: false,
    postSlotCancellation: async (payload, toast, fetchCustomerData, caseId) => {
      set({ slotCancellationLoading: true });
      try {
        await cancelSlotApi(payload);
        set({ slotCancellationLoading:false });
        fetchCustomerData(caseId);
        toast.success('Slot Cancelled successfully', TOAST_MESSAGE_CSS)
      } catch (error) {
        set({ isError: true, data: [] });
        toast.error(error?.response?.data?.message||'Slot Cancellation Failed', TOAST_MESSAGE_CSS)
      } finally {
        set({ slotCancellationLoading: false });
      }
    },
  }));